// import { useState } from "react";
import { toSlug } from "utils";
import styles from "./Footer.module.css";
// import { FaLinkedin, FaFacebook, FaTwitter } from 'react-icons/fa';
import { Link } from "react-router-dom";
// import { LogoDot, LogoI, LogoStem, LogoText } from './Logo_old';
import linkedImage from "../../assets/images/linkedin.svg";
import twitterImage from "../../assets/images/twitter.svg";
import facebookImage from "../../assets/images/facebook-logo.svg";

const services = [
    "Onboarding",
    "Provider Credentialing",
    "Payor Enrollment",
    "Monitoring and Tracking",
    "Security Risk Assessment",
    "Vendor Risk Assessment",
    "Data Exchange Management",
];
const healthCare = ["Healthcare Providers", "Healthcare Support Services"];
const Footer = () => {
    // Newsletter form currently disabled; keep handlers removed to avoid unused-var warnings

    return (
        <div className={styles["footer-wrapper"]}>
            <div className={styles["footer-container"]}>
                {/* Left Side */}
                <div className={styles["footer-left"]}>
                    <Link to="/">
                        <div className={styles["logo-container"]}>
                            <svg
                                className="icon"
                                viewBox="0 0 120 150"
                                preserveAspectRatio="xMidYMid meet"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    className="background"
                                    x="0"
                                    y="0"
                                    width="120"
                                    height="140"
                                    rx="20"
                                />
                                <path
                                    className="uShape"
                                    d="
                          M 40 35 
                          L 23 40 
                          C 23 45, 18 75, 33 95
                          C 45 115, 75 115, 87 95
                          C 102 75, 97 45, 97 40 
                          L 80 35"
                                />
                                <circle
                                    className="earpiece"
                                    cx="40"
                                    cy="35"
                                    r="5"
                                />
                                <circle
                                    className="earpiece"
                                    cx="80"
                                    cy="35"
                                    r="5"
                                />
                                <path
                                    className="bottomTip"
                                    d="M55 107 Q60 133 65 107"
                                />
                                <rect
                                    className="iStem"
                                    x="53"
                                    y="55"
                                    width="15"
                                    height="35"
                                    rx="2"
                                />
                                <line
                                    className="iLine"
                                    x1="53"
                                    y1="55"
                                    x2="68"
                                    y2="55"
                                />
                                <circle
                                    className="orangeDot"
                                    cx="60"
                                    cy="38"
                                    r="8"
                                />
                            </svg>
                            {/* Text  */}
                            <div className="logo-text">Credentialing</div>
                        </div>
                    </Link>

                    <div className={styles["footer-contact"]}>
                        <div className={styles["address"]}>
                            <h4>Address:</h4>
                            <p>2372 Morse Ave. #1020</p>
                            <p>Irvine CA 92614</p>
                        </div>
                        <div className={styles["phone-email"]}>
                            <div className={styles["contact-phone"]}>
                                <h4>Phone:</h4>
                                <p>(949) 390-2661</p>
                            </div>

                            <div className={styles["contact-email"]}>
                                <h4>Email:</h4>
                                <p> info@iCredentialing.com</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Side */}
                <div className={styles["footer-center"]}>
                    {/* <div className={styles["footer-newsletter"]}>
            <h3>Follow the latest trends</h3>
            <p>With our daily newsletter</p>
            
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="youremail@example.com"
                required
              />
              <button type="submit"><strong>Subscribe</strong></button>
            </form>
          </div> */}
                </div>
                <div className={styles["footer-right"]}>
                    <div className={styles["serve"]}>
                        <h4>WHO WE SERVE</h4>
                        <ul>
                            {healthCare.map((ele) => (
                                <li key={toSlug(ele)}>
                                    <Link to={"who-we-serve/" + toSlug(ele)}>
                                        {ele}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={styles["services"]}>
                        <h4>SERVICES</h4>
                        <ul>
                            {services.map((service) => (
                                <li key={service}>
                                    <Link to={`/services/${toSlug(service)}`}>{service}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <div className={styles["footer-disclaimer-wrapper"]}>
                <p className={styles["footer-disclaimer"]}>
                    iCredentialing provides credentialing workflow automation and administrative support services.
                    Final credentialing, privileging, and payer enrollment decisions remain the responsibility of
                    the healthcare organization or payer.
                </p>
            </div>
            <div className={styles["footer-bottom"]}>
                <div className={styles["footer-links"]}>
                    <Link to="/termsofuse">Terms Of Use</Link> |{" "}
                    <Link to="/privacypolicy">Privacy Policy</Link>
                </div>
                <div className={styles["footer-social"]}>
                    <a
                        href="https://www.linkedin.com/company/innovative-health-systems-california"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {/* <FaLinkedin style={{ color: '#0A66C2', fontSize: '2rem' }}/> */}
                        <img
                            src={linkedImage}
                            className={styles.footerIcon}
                            alt="linkedin"
                        />
                    </a>
                    <a
                        href="https://facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={facebookImage}
                            className={styles.footerIcon}
                            alt="facebook"
                        />
                    </a>
                    <a
                        href="https://twitter.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={twitterImage}
                            className={styles.footerIcon}
                            alt="twitter"
                        />
                    </a>
                </div>
                <p>&copy; 2025 iCredentialing</p>
            </div>
        </div>
    );
};

export default Footer;
